// extracted by mini-css-extract-plugin
export default {"card":"jGQ69","content":"l3uhp","header":"Ptm5T","text":"opbzd"};